/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPCOUNTRY } from './IAPCOUNTRY';
import {
    IAPCOUNTRYFromJSON,
    IAPCOUNTRYFromJSONTyped,
    IAPCOUNTRYToJSON,
} from './IAPCOUNTRY';
import type { IAPETHNICITY } from './IAPETHNICITY';
import {
    IAPETHNICITYFromJSON,
    IAPETHNICITYFromJSONTyped,
    IAPETHNICITYToJSON,
} from './IAPETHNICITY';
import type { IAPGENDER } from './IAPGENDER';
import {
    IAPGENDERFromJSON,
    IAPGENDERFromJSONTyped,
    IAPGENDERToJSON,
} from './IAPGENDER';
import type { IAPLANGUAGE } from './IAPLANGUAGE';
import {
    IAPLANGUAGEFromJSON,
    IAPLANGUAGEFromJSONTyped,
    IAPLANGUAGEToJSON,
} from './IAPLANGUAGE';
import type { IAPMARITALSTATUS } from './IAPMARITALSTATUS';
import {
    IAPMARITALSTATUSFromJSON,
    IAPMARITALSTATUSFromJSONTyped,
    IAPMARITALSTATUSToJSON,
} from './IAPMARITALSTATUS';
import type { IAPNATUREOFPERSON } from './IAPNATUREOFPERSON';
import {
    IAPNATUREOFPERSONFromJSON,
    IAPNATUREOFPERSONFromJSONTyped,
    IAPNATUREOFPERSONToJSON,
} from './IAPNATUREOFPERSON';
import type { IAPORGANISATIONCLASSIFICATION } from './IAPORGANISATIONCLASSIFICATION';
import {
    IAPORGANISATIONCLASSIFICATIONFromJSON,
    IAPORGANISATIONCLASSIFICATIONFromJSONTyped,
    IAPORGANISATIONCLASSIFICATIONToJSON,
} from './IAPORGANISATIONCLASSIFICATION';
import type { IAPORGANISATIONSUBCLASSIFICATION } from './IAPORGANISATIONSUBCLASSIFICATION';
import {
    IAPORGANISATIONSUBCLASSIFICATIONFromJSON,
    IAPORGANISATIONSUBCLASSIFICATIONFromJSONTyped,
    IAPORGANISATIONSUBCLASSIFICATIONToJSON,
} from './IAPORGANISATIONSUBCLASSIFICATION';
import type { IAPPARTYTYPE } from './IAPPARTYTYPE';
import {
    IAPPARTYTYPEFromJSON,
    IAPPARTYTYPEFromJSONTyped,
    IAPPARTYTYPEToJSON,
} from './IAPPARTYTYPE';
import type { IAPTITLE } from './IAPTITLE';
import {
    IAPTITLEFromJSON,
    IAPTITLEFromJSONTyped,
    IAPTITLEToJSON,
} from './IAPTITLE';
import type { ProposalViewModel } from './ProposalViewModel';
import {
    ProposalViewModelFromJSON,
    ProposalViewModelFromJSONTyped,
    ProposalViewModelToJSON,
} from './ProposalViewModel';

/**
 * 
 * @export
 * @interface PartyViewModel
 */
export interface PartyViewModel {
    /**
     * 
     * @type {number}
     * @memberof PartyViewModel
     */
    id: number;
    /**
     * 
     * @type {IAPPARTYTYPE}
     * @memberof PartyViewModel
     */
    partyTypeId: IAPPARTYTYPE;
    /**
     * 
     * @type {IAPTITLE}
     * @memberof PartyViewModel
     */
    titleId?: IAPTITLE;
    /**
     * 
     * @type {IAPNATUREOFPERSON}
     * @memberof PartyViewModel
     */
    personTypeId?: IAPNATUREOFPERSON;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    initials?: string;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    middleName?: string;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    surname?: string;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    previousSurname?: string;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    preferredName?: string;
    /**
     * 
     * @type {IAPGENDER}
     * @memberof PartyViewModel
     */
    genderId?: IAPGENDER;
    /**
     * 
     * @type {IAPMARITALSTATUS}
     * @memberof PartyViewModel
     */
    martialStatusId?: IAPMARITALSTATUS;
    /**
     * 
     * @type {boolean}
     * @memberof PartyViewModel
     */
    hasFounders?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PartyViewModel
     */
    hasTrustees?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PartyViewModel
     */
    hasTrustBeneficiaries?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PartyViewModel
     */
    hasPersonsAuthorised?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PartyViewModel
     */
    hasSouthAfricanIDNumber?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof PartyViewModel
     */
    dateOfBirth?: Date;
    /**
     * 
     * @type {IAPCOUNTRY}
     * @memberof PartyViewModel
     */
    nationalityCountryId?: IAPCOUNTRY;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    identityNumber?: string;
    /**
     * 
     * @type {IAPCOUNTRY}
     * @memberof PartyViewModel
     */
    countryOfBirthId?: IAPCOUNTRY;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    passportNumber?: string;
    /**
     * 
     * @type {IAPCOUNTRY}
     * @memberof PartyViewModel
     */
    passportCountryOfIssue?: IAPCOUNTRY;
    /**
     * 
     * @type {Date}
     * @memberof PartyViewModel
     */
    passportExpiryDate?: Date;
    /**
     * 
     * @type {IAPETHNICITY}
     * @memberof PartyViewModel
     */
    ethnicity?: IAPETHNICITY;
    /**
     * 
     * @type {boolean}
     * @memberof PartyViewModel
     */
    allTrustBeneficiariesAreIndividuals?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    organisationName?: string;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    registrationNumber?: string;
    /**
     * 
     * @type {IAPCOUNTRY}
     * @memberof PartyViewModel
     */
    countryOfResidenceId?: IAPCOUNTRY;
    /**
     * 
     * @type {Date}
     * @memberof PartyViewModel
     */
    dateOfIncorporation?: Date;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    tradingName?: string;
    /**
     * 
     * @type {IAPNATUREOFPERSON}
     * @memberof PartyViewModel
     */
    organisationTypeId?: IAPNATUREOFPERSON;
    /**
     * 
     * @type {IAPCOUNTRY}
     * @memberof PartyViewModel
     */
    registrationNumberCountryId?: IAPCOUNTRY;
    /**
     * 
     * @type {IAPCOUNTRY}
     * @memberof PartyViewModel
     */
    incorporationCountryId?: IAPCOUNTRY;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    businessActivity?: string;
    /**
     * 
     * @type {IAPLANGUAGE}
     * @memberof PartyViewModel
     */
    contactCommunicationLanguageId?: IAPLANGUAGE;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    contactPersonName?: string;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    contactPersonSurname?: string;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    contactPersonInitials?: string;
    /**
     * 
     * @type {IAPTITLE}
     * @memberof PartyViewModel
     */
    contactPersonTitleId?: IAPTITLE;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    contactPersonDesignation?: string;
    /**
     * 
     * @type {IAPORGANISATIONCLASSIFICATION}
     * @memberof PartyViewModel
     */
    organisationClassificationId?: IAPORGANISATIONCLASSIFICATION;
    /**
     * 
     * @type {IAPORGANISATIONSUBCLASSIFICATION}
     * @memberof PartyViewModel
     */
    organisationSubClassificationId?: IAPORGANISATIONSUBCLASSIFICATION;
    /**
     * 
     * @type {IAPORGANISATIONSUBCLASSIFICATION}
     * @memberof PartyViewModel
     */
    noGIINumberReason?: IAPORGANISATIONSUBCLASSIFICATION;
    /**
     * 
     * @type {string}
     * @memberof PartyViewModel
     */
    giiNumber?: string;
    /**
     * 
     * @type {IAPLANGUAGE}
     * @memberof PartyViewModel
     */
    languageId?: IAPLANGUAGE;
    /**
     * 
     * @type {boolean}
     * @memberof PartyViewModel
     */
    isUsCitizen?: boolean;
    /**
     * 
     * @type {IAPCOUNTRY}
     * @memberof PartyViewModel
     */
    countryOfOperationId?: IAPCOUNTRY;
    /**
     * 
     * @type {ProposalViewModel}
     * @memberof PartyViewModel
     */
    proposal?: ProposalViewModel;
}

/**
 * Check if a given object implements the PartyViewModel interface.
 */
export function instanceOfPartyViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "partyTypeId" in value;

    return isInstance;
}

export function PartyViewModelFromJSON(json: any): PartyViewModel {
    return PartyViewModelFromJSONTyped(json, false);
}

export function PartyViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartyViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['Id'],
        'partyTypeId': IAPPARTYTYPEFromJSON(json['PartyTypeId']),
        'titleId': !exists(json, 'TitleId') ? undefined : IAPTITLEFromJSON(json['TitleId']),
        'personTypeId': !exists(json, 'PersonTypeId') ? undefined : IAPNATUREOFPERSONFromJSON(json['PersonTypeId']),
        'firstName': !exists(json, 'FirstName') ? undefined : json['FirstName'],
        'initials': !exists(json, 'Initials') ? undefined : json['Initials'],
        'middleName': !exists(json, 'MiddleName') ? undefined : json['MiddleName'],
        'surname': !exists(json, 'Surname') ? undefined : json['Surname'],
        'previousSurname': !exists(json, 'PreviousSurname') ? undefined : json['PreviousSurname'],
        'preferredName': !exists(json, 'PreferredName') ? undefined : json['PreferredName'],
        'genderId': !exists(json, 'GenderId') ? undefined : IAPGENDERFromJSON(json['GenderId']),
        'martialStatusId': !exists(json, 'MartialStatusId') ? undefined : IAPMARITALSTATUSFromJSON(json['MartialStatusId']),
        'hasFounders': !exists(json, 'HasFounders') ? undefined : json['HasFounders'],
        'hasTrustees': !exists(json, 'HasTrustees') ? undefined : json['HasTrustees'],
        'hasTrustBeneficiaries': !exists(json, 'HasTrustBeneficiaries') ? undefined : json['HasTrustBeneficiaries'],
        'hasPersonsAuthorised': !exists(json, 'HasPersonsAuthorised') ? undefined : json['HasPersonsAuthorised'],
        'hasSouthAfricanIDNumber': !exists(json, 'HasSouthAfricanIDNumber') ? undefined : json['HasSouthAfricanIDNumber'],
        'dateOfBirth': !exists(json, 'DateOfBirth') ? undefined : (new Date(json['DateOfBirth'])),
        'nationalityCountryId': !exists(json, 'NationalityCountryId') ? undefined : IAPCOUNTRYFromJSON(json['NationalityCountryId']),
        'identityNumber': !exists(json, 'IdentityNumber') ? undefined : json['IdentityNumber'],
        'countryOfBirthId': !exists(json, 'CountryOfBirthId') ? undefined : IAPCOUNTRYFromJSON(json['CountryOfBirthId']),
        'passportNumber': !exists(json, 'PassportNumber') ? undefined : json['PassportNumber'],
        'passportCountryOfIssue': !exists(json, 'PassportCountryOfIssue') ? undefined : IAPCOUNTRYFromJSON(json['PassportCountryOfIssue']),
        'passportExpiryDate': !exists(json, 'PassportExpiryDate') ? undefined : (new Date(json['PassportExpiryDate'])),
        'ethnicity': !exists(json, 'Ethnicity') ? undefined : IAPETHNICITYFromJSON(json['Ethnicity']),
        'allTrustBeneficiariesAreIndividuals': !exists(json, 'AllTrustBeneficiariesAreIndividuals') ? undefined : json['AllTrustBeneficiariesAreIndividuals'],
        'organisationName': !exists(json, 'OrganisationName') ? undefined : json['OrganisationName'],
        'registrationNumber': !exists(json, 'RegistrationNumber') ? undefined : json['RegistrationNumber'],
        'countryOfResidenceId': !exists(json, 'CountryOfResidenceId') ? undefined : IAPCOUNTRYFromJSON(json['CountryOfResidenceId']),
        'dateOfIncorporation': !exists(json, 'DateOfIncorporation') ? undefined : (new Date(json['DateOfIncorporation'])),
        'tradingName': !exists(json, 'TradingName') ? undefined : json['TradingName'],
        'organisationTypeId': !exists(json, 'OrganisationTypeId') ? undefined : IAPNATUREOFPERSONFromJSON(json['OrganisationTypeId']),
        'registrationNumberCountryId': !exists(json, 'RegistrationNumberCountryId') ? undefined : IAPCOUNTRYFromJSON(json['RegistrationNumberCountryId']),
        'incorporationCountryId': !exists(json, 'IncorporationCountryId') ? undefined : IAPCOUNTRYFromJSON(json['IncorporationCountryId']),
        'businessActivity': !exists(json, 'BusinessActivity') ? undefined : json['BusinessActivity'],
        'contactCommunicationLanguageId': !exists(json, 'ContactCommunicationLanguageId') ? undefined : IAPLANGUAGEFromJSON(json['ContactCommunicationLanguageId']),
        'contactPersonName': !exists(json, 'ContactPersonName') ? undefined : json['ContactPersonName'],
        'contactPersonSurname': !exists(json, 'ContactPersonSurname') ? undefined : json['ContactPersonSurname'],
        'contactPersonInitials': !exists(json, 'ContactPersonInitials') ? undefined : json['ContactPersonInitials'],
        'contactPersonTitleId': !exists(json, 'ContactPersonTitleId') ? undefined : IAPTITLEFromJSON(json['ContactPersonTitleId']),
        'contactPersonDesignation': !exists(json, 'ContactPersonDesignation') ? undefined : json['ContactPersonDesignation'],
        'organisationClassificationId': !exists(json, 'OrganisationClassificationId') ? undefined : IAPORGANISATIONCLASSIFICATIONFromJSON(json['OrganisationClassificationId']),
        'organisationSubClassificationId': !exists(json, 'OrganisationSubClassificationId') ? undefined : IAPORGANISATIONSUBCLASSIFICATIONFromJSON(json['OrganisationSubClassificationId']),
        'noGIINumberReason': !exists(json, 'NoGIINumberReason') ? undefined : IAPORGANISATIONSUBCLASSIFICATIONFromJSON(json['NoGIINumberReason']),
        'giiNumber': !exists(json, 'GiiNumber') ? undefined : json['GiiNumber'],
        'languageId': !exists(json, 'LanguageId') ? undefined : IAPLANGUAGEFromJSON(json['LanguageId']),
        'isUsCitizen': !exists(json, 'IsUsCitizen') ? undefined : json['IsUsCitizen'],
        'countryOfOperationId': !exists(json, 'CountryOfOperationId') ? undefined : IAPCOUNTRYFromJSON(json['CountryOfOperationId']),
        'proposal': !exists(json, 'Proposal') ? undefined : ProposalViewModelFromJSON(json['Proposal']),
    };
}

export function PartyViewModelToJSON(value?: PartyViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'PartyTypeId': IAPPARTYTYPEToJSON(value.partyTypeId),
        'TitleId': IAPTITLEToJSON(value.titleId),
        'PersonTypeId': IAPNATUREOFPERSONToJSON(value.personTypeId),
        'FirstName': value.firstName,
        'Initials': value.initials,
        'MiddleName': value.middleName,
        'Surname': value.surname,
        'PreviousSurname': value.previousSurname,
        'PreferredName': value.preferredName,
        'GenderId': IAPGENDERToJSON(value.genderId),
        'MartialStatusId': IAPMARITALSTATUSToJSON(value.martialStatusId),
        'HasFounders': value.hasFounders,
        'HasTrustees': value.hasTrustees,
        'HasTrustBeneficiaries': value.hasTrustBeneficiaries,
        'HasPersonsAuthorised': value.hasPersonsAuthorised,
        'HasSouthAfricanIDNumber': value.hasSouthAfricanIDNumber,
        'DateOfBirth': value.dateOfBirth === undefined ? undefined : (value.dateOfBirth.toISOString()),
        'NationalityCountryId': IAPCOUNTRYToJSON(value.nationalityCountryId),
        'IdentityNumber': value.identityNumber,
        'CountryOfBirthId': IAPCOUNTRYToJSON(value.countryOfBirthId),
        'PassportNumber': value.passportNumber,
        'PassportCountryOfIssue': IAPCOUNTRYToJSON(value.passportCountryOfIssue),
        'PassportExpiryDate': value.passportExpiryDate === undefined ? undefined : (value.passportExpiryDate.toISOString()),
        'Ethnicity': IAPETHNICITYToJSON(value.ethnicity),
        'AllTrustBeneficiariesAreIndividuals': value.allTrustBeneficiariesAreIndividuals,
        'OrganisationName': value.organisationName,
        'RegistrationNumber': value.registrationNumber,
        'CountryOfResidenceId': IAPCOUNTRYToJSON(value.countryOfResidenceId),
        'DateOfIncorporation': value.dateOfIncorporation === undefined ? undefined : (value.dateOfIncorporation.toISOString()),
        'TradingName': value.tradingName,
        'OrganisationTypeId': IAPNATUREOFPERSONToJSON(value.organisationTypeId),
        'RegistrationNumberCountryId': IAPCOUNTRYToJSON(value.registrationNumberCountryId),
        'IncorporationCountryId': IAPCOUNTRYToJSON(value.incorporationCountryId),
        'BusinessActivity': value.businessActivity,
        'ContactCommunicationLanguageId': IAPLANGUAGEToJSON(value.contactCommunicationLanguageId),
        'ContactPersonName': value.contactPersonName,
        'ContactPersonSurname': value.contactPersonSurname,
        'ContactPersonInitials': value.contactPersonInitials,
        'ContactPersonTitleId': IAPTITLEToJSON(value.contactPersonTitleId),
        'ContactPersonDesignation': value.contactPersonDesignation,
        'OrganisationClassificationId': IAPORGANISATIONCLASSIFICATIONToJSON(value.organisationClassificationId),
        'OrganisationSubClassificationId': IAPORGANISATIONSUBCLASSIFICATIONToJSON(value.organisationSubClassificationId),
        'NoGIINumberReason': IAPORGANISATIONSUBCLASSIFICATIONToJSON(value.noGIINumberReason),
        'GiiNumber': value.giiNumber,
        'LanguageId': IAPLANGUAGEToJSON(value.languageId),
        'IsUsCitizen': value.isUsCitizen,
        'CountryOfOperationId': IAPCOUNTRYToJSON(value.countryOfOperationId),
        'Proposal': ProposalViewModelToJSON(value.proposal),
    };
}

